<div>
	<h1
		mat-dialog-title
		*ngIf="data.title"
	>{{ data.title }}</h1>
	<form
		*ngIf="data.controls as controls"
		[formGroup]="form"
		cForm
		class="d-flex flex-column bg-white p-2 rounded shadow-sm"
	>
		<ng-container *ngFor="let control of controls">
			<c-col
				xs="12"
				*ngIf="getCtrl(control.key) as ctrl"
			>
				<label
					cLabel
					[for]="control.key"
					class="w-100"
				>{{ control.label | titlecase }}</label>

				<!-- TODO: Add more input types when needed -->

				<ng-container [ngSwitch]="control.inputType">
					<ng-container *ngSwitchCase="'date'">
						<c-date-picker [formControlName]="control.key"></c-date-picker>
					</ng-container>

					<ng-container *ngSwitchCase="'select'">
						<select
							cSelect
							[id]="control.key"
							[value]="null"
							[formControlName]="control.key"
							class="w-100"
						>
							<option [value]="null">
								Elija una opción
							</option>
							<option
								*ngFor="let option of control.options"
								[value]="option.id"
							>
								{{ option.name }}
							</option>
						</select>
					</ng-container>

					<ng-container *ngSwitchDefault>
						<input
							cFormControl
							[id]="control.key"
							[formControlName]="control.key"
							[type]="control.inputType"
							[placeholder]="control.placeholder ?? control.label"
							class="w-100"
						/>
					</ng-container>
				</ng-container>
			</c-col>
		</ng-container>

		<c-row class="w-100 m-0 p-2">
			<c-col
				xs="12"
				class="d-flex justify-content-center justify-content-lg-end gap-3"
			>
				<button
					cButton
					color="primary"
					variant="outline"
					type="button"
					(click)="close(false)"
				>
					Cancelar
				</button>
				<button
					cButton
					color="primary"
					type="submit"
					[disabled]="form?.invalid"
					(click)="close(true)"
				>
					Guardar
				</button>
			</c-col>
		</c-row>
	</form>
</div>
